export const API_BASE_URL = 'https://1fiveglobal.in/api/';
export const PRODUCT_API_BASE_URL = 'https://1fiveglobal.in/api/';
export const AUTH_API_BASE_URL = 'https://skdm.in/server/onefiveapi/';
export const LEAD_API_BASE_URL = 'https://skdm.in/server/v1/';


// export const API_BASE_URL = 'https://1fiveglobal.in/api/';
// export const PRODUCT_API_BASE_URL = 'https://1fiveglobal.in/api/';
// export const AUTH_API_BASE_URL = 'https://skdm.in/server/onefiveapi/';
// export const LEAD_API_BASE_URL = 'https://skdm.in/server/v1/';